import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuth } from "src/contexts/AuthContext";
import { ROUTES } from "@/constants/routes";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!user) {
      router.push(ROUTES.LOGIN);
    }
  }, [router, user]);

  return <>{user ? children : null}</>;
};

export default ProtectedRoute;
